import service from '@/assets/js/request'

//通话记录
export const getCdrList = (host, data = {}) => {
  return service({
    url: `${host}/api/v3/cdr/cdr/list`,
    method: 'post',
    data
  })
}

//未接来电
export const getCdrLostList = (host, data = {}) => {
  return service({
    url: `${host}/api/v3/cdr/lost/list`,
    method: 'post',
    data
  })
}

//稍后联系
export const getContactLists = (host, data = {}) => {
  return service({
    url: `${host}/api/v3/contact/lists`,
    method: 'get',
    params: data
  })
}

// 更新未接来电处理状态
export const updateDealStatus = (host, data = {}) => {
  return service({
    url: `${host}/api/v3/cdr/update/dealstatus`,
    method: 'post',
    data
  })
}

//打电话更新状态
export const updateLaterSolve = (host, data = {}) => {
  return service({
    url: `${host}/api/v3/contact/solve`,
    method: 'post',
    data
  })
}

//打电话
export const getPhoneCallId = (host, data = {}) => {
  return service({
    url: `${host}/api/v3/users/callOut`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/ektv3.js